import { ArticleProvider } from "store/articleStore";
import { CartProvider } from "store/cartStore";
import { DeliveryOptionsProvider } from "store/deliveryOptionsStore";
import { MenuProvider } from "store/menuStore";
import { PlaceProvider } from "store/placeStore";
import { ProtectedRoutes } from "types/routes";
import RouteWrapper from "components/route-wrapper/RouteWrapper";
import ProtectedRoute from "components/protected-route/ProtectedRoute";
import Menu from "./components/menu/Menu";

function MenuRoute() {
	return (
		<PlaceProvider>
			<DeliveryOptionsProvider>
				<MenuProvider>
					<ArticleProvider>
						<CartProvider>
							<RouteWrapper route={ProtectedRoutes.MENU}>
								<ProtectedRoute route={ProtectedRoutes.MENU}>
									<Menu />
								</ProtectedRoute>
							</RouteWrapper>
						</CartProvider>
					</ArticleProvider>
				</MenuProvider>
			</DeliveryOptionsProvider>
		</PlaceProvider>
	);
}

export default MenuRoute;
